import { Grid } from "@mui/material";
import Story from "./Story";

const Stories = ({ stories, classes, projectData }) => {
  if (!Array.isArray(stories)) {
    return null;
  }

  return (
    <Grid container spacing={2} className={classes.centeredTabs}>
      {stories.map((story, i) => {
        // For daily deals, show all stories; otherwise filter by those with KPIs
        if (!story.storyKPIs && !projectData.isDailyDeal) {
          return null;
        }

        return (
          <div
            key={story.id}
            style={{ width: "100%", marginTop: "8px", marginBottom: "8px" }}
          >
            <Story classes={classes} story={story} index={i} />
          </div>
        );
      })}
    </Grid>
  );
};

export default Stories;
